import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { Subscription, Observable, from } from "rxjs";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
} from "@angular/forms";
import { ModalCarpetaEjecutivaComponent } from "../modal-carpeta-ejecutiva/modal-carpeta-ejecutiva.component";
import { AutenticacionService } from "src/app/services/autenticacion.service";
import { ActivatedRoute } from "@angular/router";
import {
  trigger,
  state,
  style,
  transition,
  animate,
} from "@angular/animations";
import { FacadeSesionService } from "src/app/services/facade-sesion.service";
import { Estado } from "src/app/models/entities/estado";
import { RutaCatalogoEnum } from "src/app/shared/enums/ruta-catalogo.enum";
import { take, concatMap, map, toArray, filter, tap } from "rxjs/operators";
import { CatalogoService } from "src/app/services/catalogo.service";
import { LevantamientoObra } from "src/app/models/entities/levantamiento-obra";
import { ObraService } from "src/app/services/obra.service";
import { LevantamientoObraService } from "src/app/services/levantamiento-obra.service";
import { ObraDTO } from "src/app/models/dtos/obra-dto";
import { Obra } from "src/app/models/entities/obra";
import { TipoConsultaEnum } from "src/app/shared/enums/tipo-consulta-enum.enum";
import { ElementoCatalogo } from "src/app/models/entities/elemento-catalogo";
import { ArchivosWebService } from "../../../../services/archivos-web.service";
import { ArchivoPDF } from "../../../../models/entities/archivoPdf";
import { PDFProgressData } from "ng2-pdf-viewer";
import { NgbModalRef, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import * as FileSaver from "file-saver";
import { Alert } from "../../../../models/alert";
import { AlertasService } from "../../../../services/alertas.service";

@Component({
  selector: "generador-carpeta",
  templateUrl: "./generador-carpeta.component.html",
  styleUrls: ["./generador-carpeta.component.scss"],
  animations: [
    // the fade-in/fade-out animation.
    trigger("fadeIn", [
      // the "in" style determines the "resting" state of the element when it is visible.
      state("in", style({ opacity: 1 })),
      // fade in when created. this could also be written as transition('void => *')
      transition(":enter", [style({ opacity: 0 }), animate(300)]),
      // fade out when destroyed. this could also be written as transition('void => *')
      transition(":leave", animate(300, style({ opacity: 0 }))),
    ]),
  ],
})
export class GeneradorCarpetaComponent implements OnInit {
  public carpetaEjecutivaForm: FormGroup;
  public estados$: Observable<Estado[]>;
  public archivosPdf: ArchivoPDF[] = [];
  public catalogoTipoObra: ElementoCatalogo[] = [];
  public obras: ObraDTO[] = [];
  public levantamientosObra: LevantamientoObra[] = [];
  public datosObra: ObraDTO;
  public tiposObra$: Observable<ElementoCatalogo[]>;
  public tipoConsulta: string = "";
  public suscripcionObras: Subscription;
  public mostrarBoton: boolean = false;
  public modalActivo: NgbModalRef;
  @ViewChild("modalPdfFichaTecnica")
  public modalPdfFichaTecnica: any;
  fichaPdf: ArchivoPDF;
  progressData: PDFProgressData;
  isLoaded = false;
  error: any;
  pdfUrl: Observable<string | null>;
  alerta: Alert = new Alert();
  completado: boolean = false;

  @ViewChild("modalCarpetaEjecutiva")
  public modalCarpetaEjecutiva: ModalCarpetaEjecutivaComponent;

  public readonly TIPO_OBRA_PROCESO: string = "0";
  public readonly TIPO_OBRA_PLANEACION: string = "1";

  constructor(
    private formBuilder: FormBuilder,
    private autenticacionService: AutenticacionService,
    private facadeSesionService: FacadeSesionService,
    private catalogoService: CatalogoService,
    private obraService: ObraService,
    private levantamientoObraService: LevantamientoObraService,
    private archivosWebService: ArchivosWebService,
    private modalService: NgbModal,
    public alertasService: AlertasService
  ) {}

  cerrarSesion() {
    this.autenticacionService.cerrarSesion();
  }

  ngOnInit() {
    this.facadeSesionService.breadcrumbService.actualizarBreadcrumbFuncionalidad(
      "Carpeta ejecutiva"
    );
    this.obtenerCatalogoEstados();
    this.inicializarForm();
  }

  private inicializarForm() {
    this.carpetaEjecutivaForm = this.formBuilder.group({
      // tipoObra: new FormControl('-1'),
      estado: new FormControl("-1"),
      // keyLevantamientoObra: new FormControl('-1')
    });

    this.carpetaEjecutivaForm.get("estado");
    // this.carpetaEjecutivaForm.get('keyLevantamientoObra').disable();
  }

  public obtenerCatalogoEstados() {
    this.estados$ = this.catalogoService
      .obtenerCatalogo<Estado>(RutaCatalogoEnum.ESTADOS)
      .pipe(take(1));
    this.tiposObra$ = this.catalogoService
      .obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.TIPOS_OBRAS)
      .pipe(take(1));
  }

  public async showInfo(): Promise<any> {
    console.log(this.carpetaEjecutivaForm.value.estado);
    this.archivosPdf = await this.archivosWebService
      .findByKeyEstado(this.carpetaEjecutivaForm.value.estado)
      .pipe(take(1))
      .toPromise();
    console.log(this.archivosPdf);
  }

  public async obtenerDatosObraSeleccionada(keyLevantamientoObra: string) {
    this.datosObra = await this.levantamientoObraService
      .findByKey(keyLevantamientoObra)
      .pipe(
        take(1),
        concatMap((levantamientoObra: LevantamientoObra) =>
          this.obraService
            .findByKeyLevantamientoObra(levantamientoObra.key)
            .pipe(
              take(1),
              concatMap((obra: Obra) =>
                this.catalogoService
                  .obtenerCatalogo<Estado>(RutaCatalogoEnum.ESTADOS)
                  .pipe(
                    take(1),
                    map((estados: Estado[]) => {
                      let estado: Estado = estados.find(
                        (estado: Estado) =>
                          estado.key === levantamientoObra.keyCatEstado
                      );
                      return {
                        nombreEstado: estado.nombre,
                        nombreObra: levantamientoObra.nombreObra,
                        nombreTramoLicitacion:
                          levantamientoObra.nombreTramoLicitacion,
                        obra,
                      } as ObraDTO;
                    })
                  )
              )
            )
        ),
        take(1)
      )
      .toPromise();
  }

  public enviarInfoModal() {
    if (this.carpetaEjecutivaForm.get("keyLevantamientoObra").value !== "-1") {
      this.modalCarpetaEjecutiva.abrirModal(this.datosObra, true);
    } else {
      this.modalCarpetaEjecutiva.abrirModalObras(this.obras, false);
    }
  }

  public ngOnDestroy(): void {
    if (this.suscripcionObras) {
      this.suscripcionObras.unsubscribe();
    }
  }

  onProgress(progressData: PDFProgressData) {
    console.log(progressData);
    this.progressData = progressData;
    this.isLoaded = false;
    this.error = null; // clear error
  }

  descargarPDF(url: string, nombre: string) {
    const pdfUrl = url;
    const pdfName = nombre;
    FileSaver.saveAs(pdfUrl, pdfName);
  }

  public cerrarModal(): void {
    this.modalActivo.close();
  }

  public abrirModalByKeyEstado(archivos: any[], nombre: string) {
    console.log(this.fichaPdf);
    this.archivosPdf = archivos;
    this.fichaPdf = archivos.find((ficha) => ficha.nombre === nombre);
    console.log(this.fichaPdf);

    this.modalActivo = this.modalService.open(this.modalPdfFichaTecnica, {
      centered: true,
      size: "lg",
      windowClass: "modal-ficha-tecnica",
    });
  }

  verArchivo(archivo: ArchivoPDF) {
    this.fichaPdf = archivo;
  }

  deleteFile(file: ArchivoPDF) {
    this.alerta.confirmacion().then((result) => {
      if (result.value === true) {
        this.archivosWebService
          .deleteFileDatabase2(file.key)
          .then(() => {
            this.archivosWebService.deleteFileStorage2(file.nombre);
            this.alertasService.mostrarAlerta(
              "success",
              "Archivo eliminado correctamente!"
            );
            this.completado = true;
            this.showInfo();
          })
          .catch((error) => {
            console.log(error);
            this.alertasService.mostrarAlerta(
              "error",
              "Error al eliminar el archivo!"
            );
            this.completado = false;
          });
      }
    });
  }
}
